import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import "./style.scss";
import Question from "../../containers/question/";
import PrintTemplate from "react-print";
import {
  dataToJS,
  isLoaded,
  pathToJS,
  firebaseConnect
} from "react-redux-firebase";
import BlankPage from "../blank/";
import DrawerToggle from "../../containers/drawer-toggle/";
import PrintStudentLog from "../../containers/print-student-log/";
class PrintStudentLogPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showing: "all"
    };
  }
  updateShowing(event) {
    this.setState({ showing: event.target.value });
  }
  componentWillMount() {
    this.props.firebase.set(
      `/responses/groups/${this.props.match.params.groupId}/logs/${this.props.match.params.logId}/students/${this.props.auth.uid}/set`,
      true
    );
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillUnmount() {}

  componentWillReceiveProps(props) {
    this.setState({ responses: this.props.responses });
  }

  render() {
    if (
      isLoaded(this.props.log) &&
      isLoaded(this.props.group) &&
      isLoaded(this.props.responses)
    ) {
      return (
        <div className="flex-container">
          <div className="content log">
            <div className="page">
              <div className="max-width">
                <div className="no-print">
                  Printing: <select
                    value={this.state.showing}
                    onChange={this.updateShowing.bind(this)}
                  >
                    <option value="all">All Students</option>
                    <option value="complete">Completed Logs</option>

                  </select>
                </div>
                {Object.keys(this.props.group.students)
                  .map((key, id) => ({
                    ...this.props.group.students[key],
                    _key: key
                  }))
                  .filter(
                    student =>
                      student.uid &&
                      student.role === this.props.match.params.role
                  )
                  .filter(
                    student =>
                      this.state.showing === "all"
                        ? true
                        : this.props.percentage &&
                            student.uid &&
                            this.props.percentage.users[student.uid] &&
                            this.props.percentage.users[student.uid].logs[
                              this.props.match.params.logId
                            ] &&
                            this.props.percentage.users[student.uid].logs[
                              this.props.match.params.logId
                            ].value == 1
                  )
                  .map(student => (
                    <div>
                      <PrintStudentLog
                        log={this.props.log}
                        student={student}
                        responses={this.props.responses[student.uid]}
                        key={student.uid}
                      />

                      <div className="pageBreak" />
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return <BlankPage />;
    }
  }
}

export default withRouter(
  connect(({ firebase }, { match, auth }) => {
    if (auth)
      return {
        group: dataToJS(firebase, `groups/${match.params.groupId}`),
        responses: dataToJS(
          firebase,
          `/responses/groups/${match.params.groupId}/logs/${match.params.logId}/students`
        ),
        log: dataToJS(firebase, `/logs/${match.params.logId}`),
        percentage: dataToJS(
          firebase,
          `/percentages/groups/${match.params.groupId}`
        )
      };
    return null;
  })(
    firebaseConnect(({ match, auth }) => {
      console.log(
        `/responses/groups/${match.params.groupId}/logs/${match.params.logId}/students`
      );
      return auth
        ? [
            "/logs",
            "/groups",
            `/responses/groups/${match.params.groupId}/logs/${match.params.logId}/students`,
            "/percentages"
          ]
        : [];
    })(PrintStudentLogPage)
  )
);



// WEBPACK FOOTER //
// ./src/routes/print-log/index.js